import React from 'react';
import styled from '@emotion/styled';
import CardWithTextSkeleton from './CardWithTextSkeleton';
import { TextSkeletons } from './HomePage';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  width: 100%;
`;

const DefaultSkeletonLoader = () => (
  <Container>
    <CardWithTextSkeleton>
      <TextSkeletons />
    </CardWithTextSkeleton>
  </Container>
);

export default DefaultSkeletonLoader;
